<template>
    <div class="container">
        <van-nav-bar title="充值详情" left-text="" left-arrow @click-left="onClickLeft">
        </van-nav-bar>
        <van-row style="background:#fff">
      <van-col span="8">
        <p class="p1">充值总金额</p>
        <p class="p2 col_o">￥{{objDetail.totalAmount}}</p>
      </van-col>
      <van-col span="8">
        <p class="p1">赠送总金额</p>
        <p class="p2 col_g">￥{{objDetail.givingAmount}}</p>
      </van-col>
      <van-col span="8">
        <p class="p1">实付总金额</p>
        <p class="p2 col_r">￥{{objDetail.payAmount}}</p>
      </van-col>
    </van-row>
        <div class="list-box">
            <div class="list">所属机构：<span>{{objDetail.organizationFullName}}</span></div>
            <div class="list">城市：<span>{{objDetail.cityName}}</span></div>
            <div class="list">所属项目：<span>{{objDetail.communityName}}</span></div>

            <div class="list">手机号码：<img class="img" src="../../assets/img/copy.png" @click="copyOrderId(objDetail.mobile)"/><span>{{objDetail.mobile}}</span></div>
            <div class="list">订单编号：<img class="img" src="../../assets/img/copy.png" @click="copyOrderId(objDetail.id)"/><span>{{objDetail.id}}</span></div>
            <div class="list">订单时间：<span>{{objDetail.createTime}}</span></div>
            <div class="list">支付方式：<span>{{objDetail.sourceDesc}}</span></div>
            <div class="list">活动名称：<span>{{objDetail.ruleName||'无'}}</span></div>
            
        </div>
        <div class="box">
            <van-button type="primary" block @click="handleRefund" :disabled="refundNum===0||disabled">申请退款</van-button>
            <p class="p3 col_r">可退金额：{{refundNum}}元</p>
        </div>
    </div>
</template>
  
<script>
import axios from '@/axios.js';
import { NavBar, Icon, Image, Toast, Loading, Button, Dialog,Col, Row, } from 'vant';
export default {
    data() {
        return {
            objDetail: {},
            refundNum: 0,
            disabled: false,
            statistics:{},
        };
    },
    components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon,
        [Image.name]: Image,
        [Toast.name]: Toast,
        [Loading.name]: Loading,
        [Button.name]: Button,
        [Dialog.name]: Dialog,
        [Col.name]: Col,
    [Row.name]: Row,
    },
    methods: {
        handleRefund() {

            Dialog.confirm({
                title: '提示',
                message: '是否进行退款',
            }).then(() => {
                // on confirm
                this.disabled=true
                axios.get("/recharge/refundorderbyorderid?rechargeOrderId=" + this.objDetail.id, {
                }).then((res) => {
                    this.disabled=false
                    if (res.isSuccess) {
                        Toast('退款成功');
                        this.$router.push({ path: "refundSuccess.html"})
                    }
                })
            }).catch(() => {
                // on cancel
            });
        },
        changePage(url) {
            this.$router.push({ path: url + ".html" })
        },
        getDetail() {
            axios.get("/recharge/getrechargeorderdetail?rechargeOrderId=" + this.$route.query.id, {
            }).then((res) => {
                this.objDetail = res.data;
                Toast.clear();
            })
            axios.get("/recharge/getrefundamount?rechargeOrderId=" + this.$route.query.id, {
            }).then((res) => {
                this.refundNum = res.data;
            })
        },

        onClickLeft() {
            // Toast('返回上一页');
            this.$router.go(-1);
            //window.history.back();
            //this.$router.replace({ path: "rechargeList.html" });
          
        },
        onClickRight() {

        },
        copyOrderId(orderId) {
            var input = document.createElement("input"); // 创建input对象
            input.value = orderId; // 设置复制内容
            document.body.appendChild(input); // 添加临时实例
            input.select(); // 选择实例内容
            document.execCommand("Copy"); // 执行复制
            document.body.removeChild(input); // 删除临时实例
            Toast('复制成功');
        },
    },
    computed: {
    },
    created() {
        Toast.loading({
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '数据加载中...'
        });
        this.getDetail();
    },
    mounted() {

    },
    destroyed() {
    }
}
</script>
<style lang="less" scoped>
body,
html {
    width: 100%;
    height: 100%;
    background: #fff
}

.container {
    width: 100%;
    min-height: 100vh;
    letter-spacing: 0px;
    background: #fff;
}

.list-box {
    width: 100%;
    color: #373737;
    padding: 12px 20px 0 20px;

    .list {
        font-size: 14px;
        width: 100%;
        line-height: 2;
        border-bottom: 1px solid #f1f1f1;
        margin-bottom: 8px;
        img{
            float: right;
            width: 18px;
            height: auto;
            margin-top: 3px;
            margin-left: 3px;
        }
        span {
            float: right
        }

        .width200 {
            width: 230px;
            display: inline-block;
        }
    }
}



.title {
    font-size: 14px;
    font-weight: bold;
    text-align: left;
    color: #373737;
    padding: 0 0 10px 20px;
}

.box {
   width: 94%;
   position: fixed;
   bottom:20px;
   left:3%;

}
.p3{
    text-align: center;
    line-height: 2;
}
.p1,.p2{
  text-align: center;
}
.p1{
  line-height: 1.5;
  padding-top: 15px;
  font-size: 13px;
}
.p2{
  line-height: 2;
  font-size: 18px;
  font-weight: 600;
}
</style>
  